export const SET_SELECTED_EMPLOYEE = 'SET_SELECTED_EMPLOYEE'
export const SET_COMPANY_CALLS_VIEW = 'SET_COMPANY_CALLS_VIEW'
export const SET_PAGINATION_STEP = 'SET_PAGINATION_STEP'
export const SET_PAGINATION_START_AFTER = 'SET_PAGINATION_START_AFTER'
